import ApiClient from './ApiClient';

class AppointmentRequestsAPI extends ApiClient {
  constructor() {
    super('appointment_requests', { accountScoped: true });
  }
}

export default new AppointmentRequestsAPI();
